<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box american-credit-partner">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<!-- <h1>Let’s join forces</h1> -->
              <h1>Brokers are American Credit®'s most important partners.</h1>
              <p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #5456ff; font-weight: 700;"><a href="/broker">Already a broker? Log In</a></span></p>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">American Credit helps brokers, sales organizations, business consultants, and direct lender grow their customer bases of small business owners by providing wide-scope of business loan programs that cover a broad range of credit spectrum. As the nation’s leading fintech asset-based lender, American Credit provides flexible lending products, easy online application, fast approval process, competitive commissions, and great services to ensure the success of you and your clients.</span></p>
              <br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="american-credit-partner-main-img" src="../assets/imgs/American-Credit-Vendor-Financing.png" alt="american credit business loan partner"/>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%; background: white;">
      <div class="container platform how-works">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1">
            <h6 class="broker-h-6"></h6>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1" style="background: #F3F6FA;">
            <h2 class="text-center partners-title">What We Look for in You</h2>
            <div class="row partner-items">
              <div class="col-6 col-lg-4 partner-item-wrapper">
                <div class="broker-item">
                  <div class="broker-item-inner">
                    <h3>2 Years</h3>
                    <p>Minimum Time in Business</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-4 partner-item-wrapper">
                <div class="broker-item">
                  <div class="broker-item-inner">
                    <h3>$0.5M</h3>
                    <p>New Business Funding per Month</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-4 partner-item-wrapper">
                <div class="broker-item">
                  <div class="broker-item-inner">
                    <h3>Functional Website</h3>
                    <p>Encrypted Website and Privacy Policy Required</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-4 partner-item-wrapper">
                <div class="broker-item">
                  <div class="broker-item-inner">
                    <h3>Due Dilligence</h3>
                    <p>Basic vetting of business. Timely response for follow up inquiries</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-4 partner-item-wrapper">
                <div class="broker-item">
                  <div class="broker-item-inner">
                    <h3>Ethical</h3>
                    <p>Fiscal Conduct</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-4 partner-item-wrapper">
                <div class="broker-item">
                  <div class="broker-item-inner">
                    <h3>U.S.-Based</h3>
                    <p>Business Location</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center broker-sign-button"><button @click="this.window.location.href='/partner'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 229px; border-radius: 26.5px; border: none;">Inquire to Be a Partner</button></div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; background-color: #83eece; color: #333333; margin-top: 40px;">
      <div class="container how-works">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1">
            <h2 class="text-center partners-title">Product Offered</h2>
            <div class="row partner-items">
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="product-item">
                  <div class="product-item-inner">
                    <h3 class="broker-product-h3">1</h3>
                    <p class="broker-product-p">Equipment Financing</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="product-item">
                  <div class="product-item-inner">
                    <h3 class="broker-product-h3">2</h3>
                    <p class="broker-product-p">Equipment Sales & Lease Back</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="product-item">
                  <div class="product-item-inner">
                    <h3 class="broker-product-h3">3</h3>
                    <p class="broker-product-p">Invoice Factoring</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="product-item">
                  <div class="product-item-inner">
                    <h3 class="broker-product-h3">4</h3>
                    <p class="broker-product-p">Working Capital</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="product-item">
                  <div class="product-item-inner">
                    <h3 class="broker-product-h3">5</h3>
                    <p class="broker-product-p">Letter of Credit</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="product-item">
                  <div class="product-item-inner">
                    <h3 class="broker-product-h3">6</h3>
                    <p class="broker-product-p">Commercial Real Estate</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center broker-sign-button"><button @click="this.window.location.href='/partner'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 229px; border-radius: 26.5px; border: none;">Inquire to Be a Partner</button></div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform referral-program">
        <div class="row referral-program-inner">
          <div class="col-12 col-lg-5 offset-lg-1 referral-program-inner-left">
            <h2>Explore More Ways to Partner with American Credit?</h2>
            <p>Not a broker, sales organization, consultant, or direct lender? We also partner with:</p>
            <div class="referral-program-inner-left-why">
              <!-- <h4>Why become a referral partner?</h4> -->
              <ul>
                <li>Publishers or content producers with captive small business audiences who could benefit from American Credit’s financing options</li>
                <li>Enterprise organizations that want to offer a leading financing solution to meet their small business customers’ needs</li>
              </ul>
            </div>
            <p>If your business fits one of the above, we have a partnership that will work for you. <span style="color: #5456ff; font-weight: 700;"><a href="/brokers#drop-a-line">Drop us a line</a></span> today.</p>
          </div>
          <div class="col-12 col-lg-5 referral-program-inner-right">
            <img src="../assets/imgs/American_Credit_Business_Loans_Referral_Program.png" alt="American Credit Business Loans Referral Program">
          </div>
        </div>
      </div>
    </div>

    <div id="drop-a-line" style="width: 100%; background: white;">
      <div class="container platform contact-us">
        <div class="row">
          <div class="col-12 col-lg-5 offset-lg-1 contact-us-left">
            <h4 class="contact-us-title">Drop us a line</h4>
            <p class="contact-us-text">Whether you want to start a partnership or become a broker, we are happy to work with you. Please feel free to send us a message.</p>
            <el-form class="row" :label-width="'0'" :model="step2Form" :rules="rules" ref="step2Form">
              <el-form-item class="col-6" prop="firstName" required>
                <el-input type="text" placeholder="First Name*" v-model="step2Form.firstName"></el-input>
              </el-form-item>
              <el-form-item class="col-6" prop="lastName" required>
                <el-input type="text" placeholder="Last Name*" v-model="step2Form.lastName"></el-input>
              </el-form-item>
              <el-form-item class="col-6" prop="email" required>
                <el-input type="text" placeholder="Email*" v-model="step2Form.email"></el-input>
              </el-form-item>
              <el-form-item class="col-6" prop="phone" required>
                <el-input type="tel" placeholder="Phone*" v-model="step2Form.phone"></el-input>
              </el-form-item>
              <el-form-item class="col-12" prop="content">
                <el-input type="textarea" placeholder="Message content." v-model="step2Form.content"></el-input>
              </el-form-item>
              <br />
              <div class="col-12">
                <el-button
                  type="primary"
                  :loading="isLoading"
                  class="rounded-pill font-weight-bold"
                  @click="submitForm"
                  style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 54px; width: 190px; border-radius: 27px; border: none; margin-top: 36px;"
                >Send Message</el-button>
                <el-form-item label prop></el-form-item>
              </div>
            </el-form>
          </div>
          <div class="col-12 col-lg-5 contact-us-right">
            <h4 class="contact-us-title">Get in touch with us</h4>
            <p class="contact-us-text">We understand. Sometimes you just want to get a few answers and move on with business.</p>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_location.png" alt="american credit location">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Address</h5>
                <p style="white-space: nowrap;">2100 Geng Road, Suite 210<br /> Palo Alto, CA 94303</p>
              </div>
            </div>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_phone.png" alt="american credit phone">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Phone</h5>
                <p><a href="tel:1855-904-0188">855-904-0188</a></p>
              </div>
            </div>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_email.png" alt="american credit email">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Email</h5>
                <p><a href="mailto:info@amcredit.com">info@amcredit.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform trust-us">
        <div class="row trust-us-box">
          <div class="col-12 col-lg-5 offset-lg-1 trust-us-inner-left">
            <div>
              <p class="trust-us-title">American Credit: The difference you can trust</p>
              <p class="trust-us-text" style="color: #686868; font-weight: 300;"><span style="font-weight: 700;">You work hard. We work hard. We share the same ethic.</span> That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.</p>
              <br />
              <div class="trust-us-button">
                <button style="width: 229px;" @click="this.window.location.href='/partner'">Inquire to Be a Partner</button>
                <p><span style="color: #3c3c3c; font-weight: 700;"><a href="/brokers#drop-a-line">Feel free to contact us <i class="fa fa-long-arrow-right" style="color: #5456ff;"></i></a></span></p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 trust-us-inner-right">
            <img src="../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png" alt="American Credit Business loans the Difference You can Trust"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";

//edited node_modules/vue-form-generator/dist/vfg.js for "(click here to show/hide options)"

export default {
  data() {
    return {
      isLoading: false,
      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        businessName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      },
      rules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Phone is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    submitForm() {
      this.$refs['step2Form'].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          var _this = this;
          api
            .postForm("/common/sysfeedback/mgxyPartner.ht", {
              tokenId: _this.userInfo.token,
              firstName: _this.step2Form.firstName,
              lastName: _this.step2Form.lastName,
              email: _this.step2Form.email,
              phone: _this.step2Form.phone,
              content: "Partnership message: " + _this.step2Form.content
            })
            .then(res => {
              this.$router.push({
                path: `/`,
                query: {}
              });
            });
        } else {
          console.log('error submit!!');
        }
      });
    }
  },
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Broker Program | American Credit";
    meta.content = "Work alongside American Creditt to empower business owners with quick & simple financing options. We love helping people acheive the American Dream. Call us!";
    keywords.content = "american credit partners, Experian, Plaid, Ocrolus, Salesforce, IBM, SBA, American Credit, amcredit";
  }
};
</script>

<style scoped lang="scss">
  @import "../assets/css/global.scss";
  @import "../assets/css/fonts.css";
  .how-works {
    .broker-h-6 {
      padding-top: 48px;
      padding-bottom: 48px;
      font-size: 16px;
      font-weight: 600;
      line-height: 28px;
    }
    .broker-sign-button {
      padding-bottom: 48px;
    }
  }
  
  .american-credit-partner {
    min-height: 590px !important;
    .business-loan-box-left-inner {
      margin-top: 100px !important;
      h1 {
        font-size: 58px !important;
      }
    }
    .american-credit-partner-main-img {
      width: 680px !important;
      margin-top: 85px !important;
    }
  }

  .partner-with-leaders-title {
    font-family: Biotif;
    color: #272727;
    font-size: 36px;
    font-weight: 700;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .partner-with-leaders {
    height: 600px;
  }

  .partner-with-leaders-text {
    color: #808080;
    font-size: 18px;
    font-weight: 300;
    line-height: 28px;
  }

  .partners-title {
    width: 627px;
    margin: auto;
    color: #000082 !important;
  }
  .partner-items {
    margin-bottom: 60px;
    .partner-item-wrapper {
      padding-left: 8px;
      padding-right: 8px;
      margin-top: 30px;
      
      .broker-item {
        border-radius: 3px;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 2px 4px 25px 0px rgba(200, 200, 200, 1);
        height: 120px;
        position: relative;
        // border: none;
        // background: transparent;
        text-align: center;
        h3 {
          font-size: 24px;
          font-weight: 700;
        }
        p {
          margin-bottom: 0;
        }
        .broker-product-h3 {
          font-size: 28px;
        }
        .broker-product-p {
          font-weight: 500;
          font-size: 18px;
          margin-bottom: 0;
        }
        .broker-item-inner {
          width: 100%;
          margin: 0;
          position: absolute;
          top: 50%;
          left: 50%;
          -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
      .product-item {
        border-radius: 3px;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 2px 4px 25px 0px rgba(222, 222, 222, 0.75);
        height: 120px;
        position: relative;
        // border: none;
        // background: transparent;
        text-align: center;
        h3 {
          font-size: 24px;
          font-weight: 700;
        }
        p {
          margin-bottom: 0;
        }
        .broker-product-h3 {
          font-size: 28px;
        }
        .broker-product-p {
          font-weight: 500;
          font-size: 18px;
          margin-bottom: 0;
        }
        .product-item-inner {
          width: 100%;
          margin: 0;
          position: absolute;
          left: 50%;
          top: 14px;
          -ms-transform: translate(-50%);
          transform: translate(-50%);
        }
      }
      .partner-item {
        border-radius: 3px;
        background-color: #ffffff;
        box-shadow: 2px 4px 25px 0px rgba(222, 222, 222, 0.75);
        height: 100px;
        text-align: center;
        img {
          margin-top: 25px;
          height: 50%;
          width: auto;
          object-fit: contain;
          max-width: 100%;
        }
      }
    }
  }

  .referral-program {
    margin-top: 110px;
    margin-bottom: 140px;
    .referral-program-inner {
      .referral-program-inner-left {
        h2 {
          font-family: Biotif;
          color: #272727;
          font-size: 36px;
          font-weight: 700;
        }
        p {
          color: #686868;
          font-size: 17px;
          font-weight: 300;
          line-height: 28px;
        }
        .referral-program-inner-left-why {
          padding-left: 0;
          margin-top: 40px;
          margin-bottom: 30px;
          h4 {
            font-family: Montserrat;
            color: #272727;
            font-size: 22px;
            font-weight: 600;
            line-height: 26px;
            margin-bottom: 30px;
          }
          ul {
            padding-left: 28px;
            li {
              display: list-item;
              list-style-image: url(../assets/imgs/list_style_icon.png);
              margin-bottom: 10px;
              padding-left: 5px;
              color: #686868;
              font-size: 18px;
              font-weight: 300;
              line-height: 28px;
            }
          }
        }
      }
      .referral-program-inner-right {
        img {
          width: 493px;
          height: auto;
          object-fit: contain;
          margin-top: 60px;
        }
      }
    }
  }

  .partners-user-feedback {
    height: 640px !important;
  }

  @media (max-width: 768px) {
    .american-credit-partner {
      min-height: 0 !important;
      .business-loan-box-left-inner {
        margin-top: 43px !important;
      }
      .american-credit-partner-main-img {
        width: 100% !important;
        margin-top: 0 !important;
        margin-bottom: 50px;
      }
    }

    .partner-with-leaders {
      height: 760px;
    }

    .partners-title {
      width: 100%;
    }

    .partner-items {
      margin-bottom: 60px;
    }

    .referral-program {
      margin-top: 60px;
      margin-bottom: 40px;
      .referral-program-inner {
        .referral-program-inner-right {
          img {
            width: 100%;
            margin-top: 40px;
          }
        }
      }
    }

    .partners-user-feedback {
      height: 780px !important;
    }
  }
  
</style>


// WEBPACK FOOTER //
// Brokers.vue?57d0ac3a